import React from 'react';

const SpamAgreement = () => {

    return (
          <>
            <div className='p-3'>
              <h2 className='fs-4'>스팸관리규약</h2>
              <div className='agree-wrap'>
                  <div className="agree-box full-height">
                      <div className="terms-wrap">
                          <div className="sec">
                              <h3>1. 용어의 정의</h3>
                              <ol>
                                  <li>(1) "스팸"이란 정보 정보통신망을 통해 수신자의 명시적인 사전 동의 없이 일방적으로 전송되는 영리목적의 광고성
                                      정보를 말한다.
                                  </li>
                                  <li>(2) "불법스팸"이란 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제50조부터 제50조의8의 규정을
                                      위반하여 전송 또는 게시되는 영리목적의 광고성 정보를 말합니다. 불법스팸은 형사 처벌 및 과태료 부과의 대상이
                                      됩니다.
                                  </li>
                              </ol>
                          </div>
                          <div className="sec">
                              <h3>2. 고객의 의무</h3>
                              <ol>
                                  <li>(1) 고객은 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 및 회사의 서비스 이용약관을 준수하여야
                                      합니다.
                                  </li>
                                  <li>(2) 고객은 스팸 또는 불법 스팸을 전송함으로써 발생하는 모든 민형사상의 책임을 부담합니다.</li>
                              </ol>
                          </div>
                          <div className="sec">
                              <h3>3. 회사의 의무</h3>
                              <ol>
                                  <li>(1) 회사는 서비스 제공목적에 맞는 서비스 이용여부를 확인하기 위하여 상시적으로 모니터링을 실시합니다</li>
                                  <li>(2) 회사는 「정보통신망 이용촉진 및 정보보호 등에 관한 법률」 제64조 제2항 및 제65조 제3항에 따라
                                      방송통신위원회 및 한국인터넷진흥원으로부터 불법스팸 전송 고객에 대한 자료의 제출 요청이 있는 경우 해당 자료를
                                      제공할 수 있습니다.
                                  </li>
                              </ol>
                          </div>
                          <div className="sec">
                              <h3>4. 고객의 이용 정지</h3>
                              <ol>
                                  <li>(1) 회사는 고객이 다음 중 하나에 해당하는 경우 서비스의 이용을 즉시 정지 또는 제한(일부 또는 전체에
                                      대하여)할 수 있습니다. <br></br>다만 이용정지의 원인이 된 사유가 완전히 해소되고 재발생할 우려가 없다고
                                      판단될 경우 서비스 이용을 가능하게 할 수 있습니다.
                                      <ol>
                                          <li>① 방송통신위원회 또는 한국인터넷진흥원이 불법스팸 전송사실을 확인하여 이용정지를 요청하는 경우
                                          </li>
                                          <li>② 전송한 광고성 정보가 불법스팸임이 확인된 경우</li>
                                          <li>③ 불법스팸 전송으로 과태료가 부과된 경우</li>
                                          <li>④ 대량으로 스팸을 전송하여 회사의 서비스제공(시스템)에 장애를 야기했거나 야기할 우려가 있는
                                              경우
                                          </li>
                                          <li>⑤ 회사가 고객에게 제공하는 서비스가 불법스팸 전송에 이용되고 있는 경우</li>
                                          <li>⑥ 회사의 서비스 제공 목적 외의 용도로 서비스를 이용하거나, 제3자에게 임의로 해당 서비스를 임대한
                                              경우
                                          </li>
                                          <li>⑦ 스팸 발송에 이용되거나 악성앱에 감염되어 스팸을 전송한 경우</li>
                                          <li>⑧ 해당 광고를 수신한 자가 수신거부를 요청하였으나 지속 재전송한 경우</li>
                                          <li>⑨ 해당 광고를 수신한 자가 스팸으로 신고한 경우</li>
                                      </ol>
                                  </li>
                                  <li>(2) 회사는 제1항의 규정에 의하여 서비스 이용을 정지하는 경우, 그 사실을 고객에게 통지합니다. 다만 미리
                                      통지하는 것이 곤란한 경우에는 이용정지 조치 후 통지할 수 있습니다.
                                  </li>
                              </ol>
                          </div>
                          <div className="sec">
                              <h3>5. 계약의 해지</h3>
                              <ol>
                                  <li>(1) 회사는 고객이 다음 중 하나에 해당하는 경우 서비스 계약을 해지할 수 있습니다.
                                      <ol>
                                          <li>① 방송통신위원회 또는 한국인터넷진흥원이 불법스팸 전송과 관련하여 계약해지를 요청하는 경우</li>
                                          <li>② 불특정 다수를 대상으로 무차별적인 스팸을 전송한 사실이 확인된 경우</li>
                                          <li>③ 고객이 전송한 광고성 정보에 대해 회사가 한국인터넷진흥원에 불법스팸 유무확인을 요청하여
                                              불법스팸임이 확인된 경우
                                          </li>
                                          <li>④ 고객이 이용정지를 당한 이후 1년 이내에 이용정지 사유가 재발한 경우</li>
                                      </ol>
                                  </li>
                              </ol>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
          </>
    );
};

export default SpamAgreement;

